module.exports = __webpack_public_path__ + "img/ring_0_0_null_0@2x.3c16ecac.png";